// src/App.js

import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ClaveForm from './views/ClaveForm';
import ArticulosList from './views/ArticulosList';
import Confirmacion from './views/Confirmacion';
import SelectArticulo from './views/SelectArticulo';

function App() {
  const [sujeto, setSujeto] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);

  // Recupera sesión solo si es válida (tiene id) y si ya envió respuestas
  useEffect(() => {
    try {
      const saved = sessionStorage.getItem('sujeto');
      if (saved) {
        const parsed = JSON.parse(saved);
        if (parsed && parsed.id) setSujeto(parsed);
      }
      if (sessionStorage.getItem('lir_submitted') === '1') {
        setIsSubmitted(true);
      }
    } catch {
      // si hay basura en storage, ignora
    }
  }, []);

  // Persiste solo si hay id
  useEffect(() => {
    if (sujeto && sujeto.id) {
      sessionStorage.setItem('sujeto', JSON.stringify(sujeto));
    } else {
      sessionStorage.removeItem('sujeto');
      sessionStorage.removeItem('lir_submitted');
      setIsSubmitted(false);
    }
  }, [sujeto]);

  const isLogged = !!(sujeto && sujeto.id);
    const tieneArticulos = !!sujeto?.tieneArticulos;
  const defaultEs = tieneArticulos
    ? '/es/articulos'
    : sujeto?.IH_Pro
      ? '/es/seleccionar-articulos'
      : '/es/articulos';
  const defaultEn = tieneArticulos
    ? '/en/articles'
    : sujeto?.IH_Pro
      ? '/en/select-articles'
      : '/en/articles';

  return (
    <Router>
      <div
        className="App"
        style={{
          fontFamily: 'Segoe UI, sans-serif',
          backgroundColor: '#292828',
          minHeight: '100vh',
          color: 'white',
          padding: 0,
          margin: 0,
        }}
      >
        <main style={{ padding: 0 }}>
          <Routes>
            {/* Default: redirige a /es */}
            <Route path="/" element={<Navigate to="/es" replace />} />

            {/* ===== ES ===== */}
            <Route
              path="/es"
              element={
                isLogged
                  ? <Navigate to={defaultEs} replace />
                  : <ClaveForm lang="es" onLogin={setSujeto} />
              }
            />
            <Route
              path="/es/articulos"
              element={
                isLogged
                  ? (
                    <ArticulosList
                      lang="es"
                      sujeto={sujeto}
                      onSubmitted={() => setIsSubmitted(true)}
                      onLogout={() => setSujeto(null)}
                    />
                  )
                  : <Navigate to="/es" replace />
              }
            />
            <Route
              path="/es/seleccionar-articulos"
              element={
                isLogged
                    ? (
                    <SelectArticulo
                      sujeto={sujeto}
                      onAssigned={(tieneArticulos) =>
                        setSujeto((prev) =>
                          prev ? { ...prev, tieneArticulos } : prev
                        )
                      }
                      onLogout={() => setSujeto(null)}
                    />
                  )
                  : <Navigate to="/es" replace />
              }
            />
            <Route
              path="/es/confirmacion"
              element={
                isLogged && isSubmitted
                  ? <Confirmacion lang="es" onLogout={() => setSujeto(null)} />
                  : <Navigate to={isLogged ? defaultEs : '/es'} replace />
              }
            />

            {/* ===== EN ===== */}
            <Route
              path="/en"
              element={
                isLogged
                  ? <Navigate to={defaultEn} replace />
                  : <ClaveForm lang="en" onLogin={setSujeto} />
              }
            />
            <Route
              path="/en/articles"
              element={
                isLogged
                    ? (
                    <ArticulosList
                      lang="en"
                      sujeto={sujeto}
                      onSubmitted={() => setIsSubmitted(true)}
                      onLogout={() => setSujeto(null)}
                    />
                  )
                  : <Navigate to="/en" replace />
              }
            />
            <Route
              path="/en/select-articles"
              element={
                isLogged
                  ? (
                    <SelectArticulo
                      sujeto={sujeto}
                      onAssigned={(tieneArticulos) =>
                        setSujeto((prev) =>
                          prev ? { ...prev, tieneArticulos } : prev
                        )
                      }
                      onLogout={() => setSujeto(null)}
                    />
                  )
                  : <Navigate to="/en" replace />
              }
            />
            <Route
              path="/en/confirmation"
              element={
                isLogged && isSubmitted
                   ? <Confirmacion lang="en" onLogout={() => setSujeto(null)} />
                  : <Navigate to={isLogged ? defaultEn : '/en'} replace />
              }
            />

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/es" replace />} />
          </Routes>
        </main>

        <footer
          style={{
            textAlign: 'center',
            padding: '1.5rem',
            backgroundColor: '#292828',
            color: '#777',
            fontSize: '0.9rem',
          }}
        >
          LIR Council &copy; {new Date().getFullYear()}
        </footer>
      </div>
    </Router>
  );
}

export default App;
